import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, catchError, map, throwError } from 'rxjs';
import { CotacaoVM } from 'src/app/api/model/cotacao-online/cotacaoVM';
import { SpinnerService } from '../../../shared/services/spinner-service.service';
import { AppConfigurationService } from '../../base/appConfiguration.service';

@Injectable({
  providedIn: 'root',
})
export class CotacaoLeadService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private toastr: ToastrService,
    private _spinnerService: SpinnerService,
  ) { }

  cadastrar(cotacaoVM: CotacaoVM): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/Price`, cotacaoVM)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  atualizar(cotacaoVM: CotacaoVM): Observable<any> {
    return this.httpClient
      .put<any>(`${this.appConfigurationService.apiBaseUrl}/Price`, cotacaoVM)
      .pipe(
        map(response => {
          return response;
        }),

        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarCotacaoPorId(id: string | undefined): Observable<any> {
    return this.httpClient
      .get<any>(`${this.appConfigurationService.apiBaseUrl}/Price/${id}`)
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarCotacoesPorIdLead(
    id: string | undefined,
    page?: any,
    itemsPerPage?: any,
    types?: any[],
  ): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/Price/GetAllByPreLead?preLeadId=${id}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarGrupoCotacaoPorLeadId(
    id: string | undefined,
    page: number = 1,
    itemsPerPage: number = 10,
    searchField?: string,
    skip: number = 0,
    take: number = 500,
  ): Observable<any> {
    // Construindo a URL base
    let url = `${this.appConfigurationService.apiBaseUrl}/Price/GetAllGroupsByPreLead?preLeadId=${id}`;

    if (searchField) {
      url += `&filter=${searchField}`;
    }

    url += `&skip=${skip}&take=${take}&pageNumber=${page}&pageSize=${itemsPerPage}`;

    return this.httpClient.get<any>(url).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listarCotacoes(
    page?: any,
    itemsPerPage?: any,
    types?: any[],
  ): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/Price`;

    if (!isNaN(page) && !isNaN(itemsPerPage)) {
      const skip = (page - 1) * itemsPerPage;
      const take = itemsPerPage;
      url += `?skip=${skip}&take=${take}`;
    }

    return this.httpClient.get<any>(url).pipe(
      map(response => response), // Mapear a resposta
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarProdutoPorIdEmpresaEntidade(entidadeId: string) {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/ContractProductCompany/GetContractCollectiveMembershipByBranchCompanyContractId?BranchCompanyContractId=${entidadeId}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  /**
   * [CORREÇÃO]: Lista os produtos vinculados à Entidade selecionada.
   * Rota correta: /ContractProductCompany/GetByBranchCompanyContractId?branchCompanyContractId=
   * (Substitui a chamada anterior que usava incorretamente GetByContractCollectiveMembershipId)
   */
  listarProdutoPorEntidade(branchCompanyContractId: string) {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/ContractProductCompany/GetByBranchCompanyContractId?branchCompanyContractId=${branchCompanyContractId}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  enviarCotacaoPorEmail(
    email: string,
    telefone?: string,
    nome?: string,
    pricesGroupId?: any,
  ): Observable<number> {
    // const formData = new FormData();
    // formData.append(
    //   'file',
    //   file,
    //   'cotacao_cliente_' + nome + '_' + Date.now().toString() + '.pdf',
    // );
    const url = `${this.appConfigurationService.apiBaseUrl}/Price/Send
?email=${email}
&name=${nome}
&pricesGroupId=${pricesGroupId}
&phone=${telefone}
`;

    return this.httpClient.post<number>(url, {}).pipe(
      map(response => {
        return response;
      }),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  listarCotacaoPorCode(code: number | undefined): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/Price/GetByCodeDetails/${code}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  listarTodasCotacoes(
    page?: any,
    itemsPerPage?: any,
    leadOrigin?: number,
    types?: any[],
    searchField?: string,
    brokerId?: string,
    brokerEmployeeId?: string,
    salesStage?: number,
    prospectStatus?: number,
    contractModalityProduct?: number,
  ): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/Price/GetAllGroups`;
    let separator = '?';

    if (!isNaN(page) && !isNaN(itemsPerPage)) {
      url += `${separator}pageNumber=${page}&pageSize=${itemsPerPage}`;
      separator = '&';
    }

    if (leadOrigin !== undefined && leadOrigin !== null && !isNaN(leadOrigin)) {
      url += `${separator}leadOrigin=${leadOrigin}`;
      separator = '&';
    }

    if (brokerId !== undefined && brokerId !== null) {
      url += `${separator}brokerId=${brokerId}`;
      separator = '&';
    }

    if (brokerEmployeeId !== undefined && brokerEmployeeId !== null) {
      url += `${separator}brokerEmployeeId=${brokerEmployeeId}`;
      separator = '&';
    }

    if (salesStage !== undefined && salesStage !== null) {
      url += `${separator}salesStage=${salesStage}`;
      separator = '&';
    }

    if (prospectStatus !== undefined && prospectStatus !== null) {
      url += `${separator}prospectStatus=${prospectStatus}`;
      separator = '&';
    }

    if (
      contractModalityProduct !== undefined &&
      contractModalityProduct !== null
    ) {
      url += `${separator}contractModalityProduct=${contractModalityProduct}`;
      separator = '&';
    }

    if (types && types.length > 0) {
      types.forEach((item: number) => {
        url += `${separator}types=${item}`;
        separator = '&'; // Para cada tipo adicionado
      });
    }

    if (searchField) {
      url += `${separator}searchField=${searchField}`;
    }

    if (searchField) url += `&searchField=${searchField}`;
    return this.httpClient.get<any>(url).pipe(
      map(response => response),
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  buscarLeadPorEmailEData(
    email: string,
    dataNascimento: string,
  ): Observable<any> {
    return this.httpClient
      .get<any>(
        `${this.appConfigurationService.apiBaseUrl}/PreLead/GetByEmailBirthDate?email=${email}&birthDate=${dataNascimento}`,
      )
      .pipe(
        map(response => {
          return response;
        }),
        catchError(err => {
          return throwError(() => ({
            message: err.message,
            status: err.status,
          }));
        }),
      );
  }

  exportarCotacao(
    typeExport: number, period: number
  ): Observable<any> {
    let url = `${this.appConfigurationService.apiBaseUrl}/Price/Prices/Export?type=${typeExport}&period=${period}`;
    return this.httpClient.get(url, { responseType: 'blob' }).pipe(
      catchError(err => {
        return throwError(() => ({
          message: err.message,
          status: err.status,
        }));
      }),
    );
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }
}
